import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner,finishSpinner } from "./ui/spinner";
import { seleccionAfiliado, traerAfiliadoXId } from "./afiliado";
import { /* evaluarDocumentacionAfiliado, */ fetchDocumentacionAfiliacion } from "./documentaciones/documentacion";
import { fetchGrupoFamiliar } from "./grupoFamiliar";
import { fetchObservaciones } from "./observaciones";
import { fetchEmpresasAfiliado } from "./empresasAfiliado";
import { fetchCertificados } from "./certificados";
import { fetchAportes } from "./aportes";
import { startAlerta } from "./ui/alertas";

export const grupoFamiliarCambioTitularidadTraerStart = () => ({ type: types.grupoFamiliarCambioTitularidadTraerStart });
export const grupoFamiliarCambioTitularidadOrigenLimpiar = () => ({
    type: types.grupoFamiliarCambioTitularidadOrigenLimpiar,
});
export const grupoFamiliarCambioTitularidadDestinoLimpiar = () => ({
    type: types.grupoFamiliarCambioTitularidadDestinoLimpiar,
});
export const grupoFamiliarCambioTitularidadTraerError = (error) => ({
    type: types.grupoFamiliarCambioTitularidadTraerError,
    payload: error,
});
export const grupoFamiliarCambioTitularidadTraerOrigenSuccess = (payload) => {
    return {
      type: types.grupoFamiliarCambioTitularidadTraerOrigenSuccess,
      payload: payload
    }
  }
export const grupoFamiliarCambioTitularidadTraerDestinoSuccess = (payload) => {
    return {
        type: types.grupoFamiliarCambioTitularidadTraerDestinoSuccess,
        payload: payload
    }
}
export const grupoFamiliarCambioTitularidadTraerDocOrigenSuccess = (payload) => {
    return {
        type: types.grupoFamiliarCambioTitularidadTraerDocOrigenSuccess,
        payload: payload
    }
}
export const grupoFamiliarCambioTitularidadTraerDocDestinoSuccess = (payload) => {
    return {
        type: types.grupoFamiliarCambioTitularidadTraerDocDestinoSuccess,
        payload: payload
    }
}
export const grupoFamiliarCambioTitularidadEvaluarDocOrigenSuccess = (payload) => {
    return {
        type: types.grupoFamiliarCambioTitularidadEvaluarDocOrigenSuccess,
        payload: payload
    }
}
export const grupoFamiliarCambioTitularidadEvaluarDocDestinoSuccess = (payload) => {
    return {
        type: types.grupoFamiliarCambioTitularidadEvaluarDocDestinoSuccess,
        payload: payload
    }
}
  
export const fetchGrupoFamiliarOrigenCambioTit = (idAfiliado) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        dispatch(grupoFamiliarCambioTitularidadTraerStart());
        const response = await fetchConToken(`GrupoFamiliares/traerGrupoFamiliarPorIdAfiliado/${idAfiliado}`);
        if (!response.ok) {
            dispatch(grupoFamiliarCambioTitularidadTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (lista.length>0) {
                dispatch(grupoFamiliarCambioTitularidadTraerOrigenSuccess(lista));
            }
        }
        dispatch(finishSpinner());
    };
};

export const fetchGrupoFamiliarDestinoCambioTit = (idAfiliado) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        dispatch(grupoFamiliarCambioTitularidadTraerStart());
        const response = await fetchConToken(`GrupoFamiliares/traerGrupoFamiliarPorIdAfiliado/${idAfiliado}`);
        if (!response.ok) {
            dispatch(grupoFamiliarCambioTitularidadTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (lista.length>0) {
                dispatch(grupoFamiliarCambioTitularidadTraerDestinoSuccess(lista));
            }
        }
        dispatch(finishSpinner());
    };
};

export const fetchDocumentacionGrupoFamiliarCambioTit = (idGrupoFamiliar, afiliados, grupo) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        dispatch(grupoFamiliarCambioTitularidadTraerStart());
        const response = await fetchConToken(`DocumentacionAfiliados/traerDocumentacionGrupoFamiliar/${idGrupoFamiliar}`);
        if (!response.ok) {
            dispatch(grupoFamiliarCambioTitularidadTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if(grupo==='origen'){
                dispatch(grupoFamiliarCambioTitularidadTraerDocOrigenSuccess(lista));
                afiliados.forEach(function(afi) { dispatch(evaluarDocumentacionAfiliadoGF(afi, grupo)) });
            }
            else if(grupo==='destino'){
                dispatch(grupoFamiliarCambioTitularidadTraerDocDestinoSuccess(lista));
                afiliados.forEach(function(afi) { dispatch(evaluarDocumentacionAfiliadoGF(afi, grupo)) });
            }
        }
        dispatch(finishSpinner());
    };
};

export const evaluarDocumentacionAfiliadoGF = (afiliado, grupo) => {
    return (dispatch, getState) => {
      let estado = true;
      const state = getState();
      const docuAfiliacion = grupo==='origen' 
                                ? state.grupoFamiliarCambioTitularidad.itemsDocOrigen.filter(s => s.idAfiliado === afiliado.id_afiliado)
                                : state.grupoFamiliarCambioTitularidad.itemsDocDestino.filter(s => s.idAfiliado === afiliado.id_afiliado);
      const {
        items: listaDocuPorParentesco,
      } = state.tipoDocumentacionParentesco;
  
      const {
        items: listaDocuPorTipoAfiliacion,
      } = state.tipoDocumentacionTipoAfiliacion;
  
      let arrayTemp = 
        (afiliado?.id_parentesco === 0)
        ? listaDocuPorTipoAfiliacion.filter( (item2) =>
            parseInt(item2.idTipoAfiliacion) === parseInt(afiliado?.id_tipo_afiliacion)
          )
        : listaDocuPorParentesco.filter(
            (item) => item.idParentesco === afiliado?.id_parentesco
          )
      ;

      //saco si hay duplis
      const arrayDocumentacion = arrayTemp.filter(
        (docu, index, self) =>
          index ===
          self.findIndex(
            (t) => t.idTipoDocumentaciones === docu.idTipoDocumentaciones
          )
      );
  
      const docuObligatoria = arrayDocumentacion.filter(
        (item) => item.obligatorio === true
      );

      docuObligatoria.forEach((docOblig, index) => {
       // let cont=0;
        const resu = docuAfiliacion.filter((item) => {
        //   if(item.idTipoDocumentaciones===1){
        //     cont++
        //   }
          return item.idTipoDocumentaciones === docOblig.idTipoDocumentaciones;
        });
        //if(docOblig.idTipoDocumentaciones === 1 && (cont<=1)){
        if(docOblig.idTipoDocumentaciones === 1){
          estado=false
        }
        if( resu.length === 0){
          estado = false;
        }
      });

      if(grupo==='origen')
        dispatch(grupoFamiliarCambioTitularidadEvaluarDocOrigenSuccess({idAfiliado: afiliado.id_afiliado, estado}));
      else if(grupo==='destino')
        dispatch(grupoFamiliarCambioTitularidadEvaluarDocDestinoSuccess({idAfiliado: afiliado.id_afiliado, estado}));
    }; 
};

export const updateGrupoFamiliar = (afiliados, idGrupoFamiliar, fechaVigencia, titular, idAfiliadoTitularGrupoOrigen = 0) => {
    return async (dispatch) => {
        try
        {
            dispatch(startSpinner());
            const response = await fetchConToken(`GrupoFamiliares/cambiarGrupoFamiliar`,{afiliados, idGrupoFamiliar, fechaVigencia, idAfiliadoTitularGrupoOrigen},'PUT');
            
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const lista = await response.json();
                if (response.status !== 200) throw lista.errores;
                dispatch( seleccionAfiliado(titular) );
                dispatch( fetchDocumentacionAfiliacion(titular?.id_afiliado) );
                dispatch( fetchGrupoFamiliar(titular?.id_afiliado) );
                dispatch( fetchObservaciones(titular?.id_afiliado) );
                dispatch( fetchEmpresasAfiliado(titular?.id_afiliado) );
                dispatch( fetchCertificados(titular?.id_afiliado) );
                dispatch( fetchAportes(titular?.cuil) );
            }
            dispatch(finishSpinner());
        } catch (err){
            dispatch(finishSpinner());
            console.log('error updateGrupoFamiliar',err);
            dispatch(startAlerta('Ocurrio un error al realizar el traspaso', "warning", `¡Error!`));
          }
    };
};

export const pasoFamiliarATitular = (afiliado, fechaVigencia) => {
    return async (dispatch) => {
       try
       {
            dispatch(startSpinner());
            const response = await fetchConToken(`GrupoFamiliares/pasoFamiliarATitular`,{idAfiliado: afiliado.id_afiliado, idGrupoFamiliar: afiliado.idGrupoFamiliar, fechaVigencia},'PUT');

            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const resp = await response.json();
                if (response.status !== 200) throw resp.errores;
                // afiliado.idGrupoFamiliar = parseInt(resp.nuevoIdGrupoFamiliar);
                // afiliado.id_parentesco = parseInt(resp.nuevoIdParentesco);
                // var date = new Date();
                // date.setDate(date.getDate() - 1);
                // afiliado.fecha_baja = date;
                // afiliado.id_motivo_baja = 36;
                // dispatch( seleccionAfiliado(afiliado) );
                dispatch( traerAfiliadoXId(afiliado?.id_afiliado) );
                dispatch( fetchDocumentacionAfiliacion(afiliado?.id_afiliado) );
                dispatch( fetchGrupoFamiliar(afiliado?.id_afiliado) );
                dispatch( fetchObservaciones(afiliado?.id_afiliado) );
                dispatch( fetchEmpresasAfiliado(afiliado?.id_afiliado) );
                dispatch( fetchCertificados(afiliado?.id_afiliado) );
                dispatch( fetchAportes(afiliado?.cuil) );
            }
            dispatch(finishSpinner());
       }catch (error){
            dispatch(finishSpinner());
            console.log('error pasoFamiliarATitular',error);
            dispatch(startAlerta('Ocurrio un error al realizar el traspaso', "warning", `¡Error!`));
       }
    };
  };

  export const pasoTitularAFamiliar = (nuevoGrupo, afiliado) => {
    return async (dispatch) => {
       try
       {
            const response = await fetchConToken(`GrupoFamiliares/pasoTitularAFamiliar`,nuevoGrupo,'PUT');

            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const resp = await response.json();
                if (response.status !== 200) throw resp.errores;
                console.log(resp);
            
                afiliado.idGrupoFamiliar = nuevoGrupo.IdGrupoFamiliarNuevo;
                afiliado.id_parentesco = nuevoGrupo.IdParentesco;
                dispatch( seleccionAfiliado(afiliado) );
                dispatch( fetchDocumentacionAfiliacion(afiliado?.id_afiliado) );
                dispatch( fetchGrupoFamiliar(afiliado?.id_afiliado) );
                dispatch( fetchObservaciones(afiliado?.id_afiliado) );
                dispatch( fetchEmpresasAfiliado(afiliado?.id_afiliado) );
                dispatch( fetchCertificados(afiliado?.id_afiliado) );
                dispatch( fetchAportes(afiliado?.cuil) );
            }
            dispatch(finishSpinner());
       }catch (error){
            dispatch(finishSpinner());
            console.log('error pasoTitularAFamiliar',error);
            dispatch(startAlerta('Ocurrio un error al realizar el traspaso', "warning", `¡Error!`));
       }
    };
  };